import { SET_REGION } from '../legacy-actions/actionTypes';

export const setRegionData = (state, action) => {
  if (action.type === SET_REGION) {
    return {
      ...state,
      regions: {
        currentRegion: action.payload,
      },
    };
  }

  return state;
};
